import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { ListGroup, ListGroupItem } from "react-bootstrap";

import Badge from "../common/Badge";

const ReportsList = ({ reports, auth }) => {
  const items = reports;
  const type = "reports";

  return (
    <ReportStyles>
      {items.map((item) => (
        <ListGroup className={type} key={item.id}>
          {item.url.includes("https") ? (
            <ListGroupItem
              className={
                auth.isNightMode ? "dark-link report-box" : "report-box"
              }
              href={item.url}
              target={item.target || "_blank"}
            >
              <div>
                {item.new && <Badge className="badge success">New</Badge>}
                {item.name}
                <div className="report-description">
                  {item.description || "No Description"}
                </div>
              </div>
            </ListGroupItem>
          ) : (
            <Link
              className={`link-report ${auth.isNightMode ? "dark-link" : ""}`}
              key={item.id}
              to={item.url}
            >
              <div>
                <div className="link-report-title">
                  <div>
                    {item.new && <Badge className="badge success">New</Badge>}
                  </div>
                  <h4>{`${item.name} Report`}</h4>
                </div>
                <div className="report-description">
                  {item.description || "No Description"}
                </div>
              </div>
            </Link>
          )}
        </ListGroup>
      ))}
    </ReportStyles>
  );
};

const ReportStyles = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
  svg {
    margin-right: 10px;
  }

  .limitedReports {
    display: grid;
    grid-gap: 15px;
  }
  .panel-title {
    font-family: "Open Sans";
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.8em;
  }
  .report-description {
    border-top: 1px solid #ddd;
    margin-top: 10px;
    padding-top: 10px;
    color: #bbb;
  }
  .dark-link {
    border: none;
  }
  .link-report {
    &:hover {
      background-color: #f2f3f8;
      color: #555;
    }
  }
  .badge {
    margin-left: 0;
  }
`;

ReportsList.propTypes = {
  reports: PropTypes.array,
  auth: PropTypes.object
};

export default ReportsList;
